// TODO: determine where wildcards are actually needed

export const advisorPath = '*administrator*';
export const advisorHomePath = '/administrator';
export const advisorPage = `${advisorHomePath}/page`;
export const advisorWhatIfPage = `${advisorHomePath}/page/what-if`;
export const advisorPageMessages = `${advisorPage}/messages`;
export const advisorTemplateManagerPage = `${advisorPage}/template-manager-page`;
export const advisorHouseholdPath = `${advisorHomePath}/household`;
export const advisorHouseholdLandingPagePath = `${advisorHouseholdPath}/landing`;
export const advisorPlanPath = `${advisorHouseholdPath}/plan`;
export const advisorPlanStartPath = `${advisorPlanPath}/start`;
export const advisorTasksPath = `${advisorHomePath}/tasks`;
export const advisorUserPath = `${advisorHomePath}/user`;
export const featuresPath = `${advisorHomePath}/features`;
export const accountRequestPath = `${advisorHomePath}/account-requests`;
export const preferencesPath = `${advisorHomePath}/preferences`;
export const advisorAssumptionsAdminPath = `${advisorHomePath}/assumptions-admin`;
export const advisorActivityFeedPath = '/administrator/feed';
export const advisorMessagesPath = '/administrator/messages';
export const advisorBulkRolloverRecommendationQuestionnaires = `${advisorHomePath}/bulk-rollover-recommendation-questionnaire`;
export const advisorIdentityVerificationReviews = `${advisorHomePath}/identity-verification-reviews`;
export const advisorHouseholdQuestionnaire = `${advisorHouseholdPath}/edit*`;
export const advisorHouseholdQuestionnairePath = `${advisorHouseholdPath}/edit`;
export const advisorHouseholdBlueprint = `${advisorHouseholdPath}/blueprint`;
export const advisorHouseholdSnapshot = `${advisorHouseholdPath}/snapshot`;
export const advisorHouseholdTimelinePath = `${advisorHouseholdPath}/timeline`;
export const advisorManagedAccountPath = `${advisorHouseholdPath}/managed-account`;
export const advisorAccountSupportPath = `${advisorHouseholdPath}/account-support`;
export const advisorSchedulerPath = `${advisorHouseholdPath}/scheduler`;
export const advisorFacetPlanPath = `${advisorHouseholdPath}/facet-plan`;

export const advisorClientExperienceSavesPath = `${advisorHomePath}/client-experience-saves`;
export const advisorClientExperiencePath = `${advisorHomePath}/client-experience`;
export const advisorLinkingAttemptsPath = `${advisorHomePath}/linking-attempts`;
export const meetingSummaryPath = `${advisorHomePath}/meeting-summary`;

export const clientPath = '*client*';
export const clientBasePath = '/client';
export const clientPage = `${clientBasePath}/page`;
export const clientPageScenarios = `${clientPage}/scenarios`;
export const clientPageOutcomes = `${clientPage}/outcomes`;
export const clientPageOnboardingReview = `${clientPage}/onboarding-review`;
export const clientPageSecurity = `${clientPage}/security`;
export const clientPageSupport = `${clientPage}/support`;
export const clientPageMessages = `${clientPage}/messages`;
export const clientDashboardPath2 = '/client/dashboard';
export const clientMeeting = '/client/meeting';
export const clientMyMeetings = '/client/my-meetings';
export const clientProfilePath = '/client/profile';
export const clientQuestionnairePath = '/client/questionnaire';
export const clientFilesPath = '/client/securefiles';
export const advisorSecureFilesPath = `${advisorHouseholdPath}/secureFiles`;
export const clientBlueprintPath = '/client/blueprint';
// Deprecated
export const deprecatedClientAccountManagement = '/client/account-management';
export const clientManagedAccount = '/client/managed-account';
export const clientGoalsPath = '/client/goals';
export const clientFlow = '/client/flow';
export const clientActivityFeed = '/client/feed';
export const clientMessages = '/client/messages';
export const clientSurvey = '/welcome/onboarding';
export const clientPageCashFlow = `${clientPage}/cash-flow`;
export const clientPagePlan = `${clientPage}/plan`;
export const clientPageBalanceSheet = `${clientPage}/balance-sheet`;

export const deprecatedPWAPaths = {
  dashboard: '/client/mobile/dashboard',
  dashboardSurvey: '/client/mobile/dashboard/survey',
  accounts: '/client/mobile/accounts',
  files: '/client/mobile/files',
  feed: '/client/mobile/feed',
  notifications: '/client/mobile/notifications',
  tasks: '/client/mobile/tasks',
  messages: '/client/mobile/messages',
  onBoardingReview: '/client/mobile/onboarding-review',
  managedAccount: '/client/mobile/accounts/managed-account',
  myMeetings: '/client/mobile/my-meetings',
};

export const clientPaths = {
  dashboard: clientDashboardPath2,
  questionnaire: clientQuestionnairePath,
  files: clientFilesPath,
  investmentProfile: clientPage,
  profile: clientProfilePath,
  meeting: clientMeeting,
  blueprint: clientBlueprintPath,
  goals: clientGoalsPath,
  flow: clientFlow,
  activityFeed: clientActivityFeed,
  messages: clientMessages,
  managedAccount: clientManagedAccount,
  myMeetings: clientMyMeetings,
  survey: clientSurvey,
  scenarios: clientPageScenarios,
  outcomes: clientPageScenarios,
  onboardingReview: clientPageOnboardingReview,
  securitySettings: clientPageSecurity,
  supportSettings: clientPageSupport,
  page: clientPage,
  messagesPage: clientPageMessages,
  cashFlowPage: clientPageCashFlow,
  planPage: clientPagePlan,
  balanceSheet: clientPageBalanceSheet,
};

export const inaccessibleInOnboardingPaths = [clientPaths.messages, clientPaths.messagesPage];

export const maintenancePath = '/maintenance';

export const changePasswordPath = '/change-password';
export const changePasswordPathExperimental = '/change-password-experimental';
export const forgotPasswordPath = '/forgot-password';
export const loginPath = '/login';
export const roleSelectionPath = '/role-selection';
export const loginExperimentalPath = '/login-experimental';
export const changePasswordExperimentalPath = '/change-password-experimental';
export const twoFactorPath = '/app/login/authenticate';

export const buyRoot = '/buy';
export const onboardingRoot = '/welcome';
export const onboardingExperimentalRoot = '/welcome-experimental';
export const onboardingSurvey = '/welcome/onboarding';
export const freemiumPath = '/discover/:uuid?';
export const userAuthSetupPath = '/user/auth/setup';

const redirectLoginRedirect = loginPath;
const redirectChangePassword = '/change-password';
const redirectTwoFactorRedirect = '/app/login/authenticate';
const redirectChangePasswordRedirect = '/signup/change-password';
const redirectAcknowledgementAgreementRedirect = '/acknowledgement/agreement';
const redirectDashboardRedirect = '/client/dashboard';
const redirectSignUpPaymentRedirect = '/signup/agreement/planning/payment';
const redirectUserAuthSetupRedirect = '/user/auth/setup';

export const redirectRouteMapper = {
  '/login': { redirect: redirectLoginRedirect },
  '/change-password': { redirect: redirectChangePassword },
  '/app/login/authenticate': { redirect: redirectTwoFactorRedirect },
  '/signup/change-password': { redirect: redirectChangePasswordRedirect },
  '/acknowledgement/agreement': {
    redirect: redirectAcknowledgementAgreementRedirect,
  },
  '/client/dashboard': { redirect: redirectDashboardRedirect },
  '/signup/agreement/planning': { redirect: onboardingRoot },
  '/signup/agreement/planning/payment': {
    redirect: redirectSignUpPaymentRedirect,
  },
  '/user/auth/setup': { redirect: redirectUserAuthSetupRedirect },
  '': { redirect: redirectDashboardRedirect },
};

export const ownerTypeHousehold = 'household';
export const ownerTypeAgent = 'agent';

export const successfulSyncStatus = 'good';

// The Facet address has changed multiple times and will change again. Just update it here.
// Don't forget to also change the backend consts.
export const facetStreetAddress = '400 East Pratt Street, 8th Floor';
export const facetCity = 'Baltimore';
export const facetState = 'MD';
export const facetZip = '21202';
export const facetAddress = `${facetStreetAddress}, ${facetCity}, ${facetState} ${facetZip}`;

// Main phone line
export const facetPhoneMain = '4433766222';

// My experience email address
export const FACET_MY_EXPERIENCE_EMAIL_ADDRESS = 'myexperience@facet.com';

// Info email address
export const facetEmailInfo = 'info@facetwealth.com';

export const boolTrue = 'true';
